import styled from 'styled-components/macro';

export const WrapperSpinner = styled.div`
  align-items: center;
  display: flex;
  height: ${({ fullscreen }) => (fullscreen ? `100vh` : `100%`)};
  justify-content: center;
  width: 100%;
`;
